// 登录相关请求
import req from './index'

//通用登录
export const universalLogin = (params) => {
  return req.post('api/admin.php?s=Admin.M3Drone.Dock_Login', params)
}

//修改密码
export const SetPassword = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.AlterPass', params)
}

//通用 获取用户信息
export const universalGetUserInfo = (params) => {
  return req.post('api/admin.php?s=Admin.M3Drone.Dock_MyProfile', params)
}

//登陆前的验证
export const getLoginVerifyApi = (params) => {
  return req.post('api/admin.php?s=Admin.Common.LoginVerify', params)
}